
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const About = lazy(() => import('../pages/about/page'));
const Services = lazy(() => import('../pages/services/page'));
const Portfolio = lazy(() => import('../pages/portfolio/page'));
const Blog = lazy(() => import('../pages/blog/page'));
const Testimonials = lazy(() => import('../pages/testimonials/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/services',
    element: <Services />,
  },
  {
    path: '/portfolio',
    element: <Portfolio />,
  },
  {
    path: '/blog',
    element: <Blog />,
  },
  {
    path: '/testimonials',
    element: <Testimonials />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
